// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'

import { string } from 'yup';


const obj =  {
	field:[
		
        { 
			title: "Source location", 
			attr: "content",  
			value: "", 
			id:"source",
			placeholder: "Specify the country to generate href tag", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Source location is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Destination location", 
			attr: "content",  
			value: "", 
			id:"destination",
			placeholder: "Specify the destination country to generate href tag", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Destination location is Required "),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
    example:[
	
        { 
			title: "Source location", 
			attr: "content",  
			value: "Any url in blog subdomain", 
			id:"source",
			placeholder: "Specify the country to generate href tag", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Source location is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "destination location", 
			attr: "content",  
			value: "A blog subdirectory within the same domain", 
			id:"destination",
			placeholder: "Specify the destination country to generate href tag", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Destination location is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output:`
		Output:RewriteEngine On 
RewriteCond %{HTTP_HOST} ^blog\.example\.com$ [OR] 
RewriteCond %{HTTP_HOST} ^www\.blog\.example\.com$ 
RewriteRule (.*)$ http://www.example.com/blog/$1 [R=301,L]
		`, 
         
        
	}
	}
	
	
	export default obj
	
	